import { ValidatedFieldData } from 'out-of-the-vue';
import { DeepReadonly, InjectionKey } from 'vue';

/**
 * The events that can be emitted
 */
export const enum EmitEvents {
    BACK = 'back',
    BLURRED = 'blurred',
    CHANGED = 'changed',
    CLICKED = 'clicked',
    CLOSED = 'closed',
    COMPLETED = 'completed',
    CREATED = 'created',
    FAILED = 'failed',
    FOCUSED = 'focused',
    FORGOT_PASSWORD = 'forgot-password',
    HIDE = 'hide',
    INTERSECT = 'intersect',
    LOGGED_IN = 'logged-in',
    LOGIN = 'login',
    NEW = 'new',
    OPENED_TAB = 'opened-new-tab',
    ORDER_CONFIRMED = 'order-confirmed',
    POLLED = 'polled',
    REMOVED = 'removed',
    SHOW = 'show',
    SIGN_IN = 'sign-in',
    SIGN_UP = 'sign-up',
    SIGNED_IN = 'signed-in',
    STOPPED = 'stopped',
    SUBMITTED = 'submitted',
    TRANSACTION_REQUESTED = 'transaction-requested',
    UPDATED = 'updated',
    WALLET_CONFIRMATION_REQUESTED = 'wallet-confirmation-requested',
    VERIFY = 'verify'
}

/**
 * Form field names
 */
export const enum FieldNames {
    CURRENCY = 'cryptocurrency',
    FIAT = 'fiat',
    CRYPTO = 'crypto',
    IBAN = 'iban',
    PAYMENT = 'payment-method',
    TAG = 'destination-tag',
    TERMS = 'terms-and-conditions',
    QUOTE = 'quote',
    WALLET = 'wallet-address'
}

/**
 * The data emitted by a form field containing the value of the field and if the field is valid
 */
export interface FormFieldData {
    value: number | string | string[] | null;
    valid: boolean;
}

export interface NumberFieldData extends FormFieldData {
    value: number | null;
}

export interface StringFieldData extends FormFieldData {
    value: string;
}

export interface FormFields {
    [name: string]: FormFieldData;
}

/**
 * Option data for selectables (radio and checkbox)
 */
export interface SelectableOption {
    identifier: string;
    value: string;
    label?: string;
    icon?: string;
    disabled?: boolean;
}

/**
 * The different types on which form fields can be validated
 */
export interface FormFieldValidity {
    required?: boolean;
    min?: boolean;
    max?: boolean;
    email?: boolean;
}

/**
 * Validated form field data from out-of-the-vue
 */
export interface ValidatedFormFields {
    [key: string]: ValidatedFieldData;
}

/**
 * Symbol for the Vue provide function to enable the error messages in all fields
 *
 * @see https://v3.vuejs.org/guide/component-provide-inject.html
 *
 * TODO: Add a type for <DeepReadonly<Ref<boolean>>> ?
 */
export const ShowFieldErrorSymbol: InjectionKey<DeepReadonly<boolean>> = Symbol('ShowFieldError');
